module.exports = __webpack_public_path__ + "img/saum_kobaltblau_ral5013.15e5ce5c.jpg";